import React, { useEffect, useState } from 'react';
import { StyledContainer } from '../../components/container/styles';
import { TextLarge } from '../../components/text';
import { RenderForm } from '../../components/forms';
import { useForm } from 'react-hook-form';
import { FORM_LOGIN_EMPLOYEE } from './form';
import { ContainerButton } from '../../styles/global-style';
import { ButtonTheme } from '../../components/buttons';
import { useGetEmployee } from './hooks/useGetEmployee';
import { openAlert } from '../../components/alert/hooks';
import { useLoginEmployee } from './hooks/useLoginEmployee';
import { useSelector } from 'react-redux';
import { ROUTES_PATH } from '../../resources/routes-name';
import { Spin } from 'antd';
import { navigateTo } from '../../utils/navigation';

export const LoginEmployee = () => {
  const [branchOptions, setBranchOptions] = useState([]);
  const { control, setValue, getValues, handleSubmit, watch, reset } = useForm();
  const { mutate: checkEmployee } = useGetEmployee();
  const { mutate: loginEmployee, isPending: loadingLogin } = useLoginEmployee();
  const { userId, displayName } = useSelector((state) => state.line.profile);

  const watchedEmployeeId = watch('employeeId');
  const [calledAutoCheck, setCalledAutoCheck] = useState(false);

  useEffect(() => {
    if (watchedEmployeeId && watchedEmployeeId.length === 13 && !calledAutoCheck) {
      setCalledAutoCheck(true);
      checkEmployee(watchedEmployeeId, {
        onSuccess: (res) => {
          const { result } = res;
          const branch = result.branchOptions.map((item) => ({
            label: item.label,
            value: item.value,
          }));
          setBranchOptions(branch);
          openAlert({
            type: 'success',
            message: res?.message,
            model: 'message',
          });
        },
        onError: (error) => {
          openAlert({
            type: 'error',
            message: error?.message,
            model: 'message',
          });
          reset({
            employeeId: getValues('employeeId'),
            branchId: '',
          });
          setBranchOptions([]);
        },
      });
    }
    if (!watchedEmployeeId || watchedEmployeeId.length !== 13) {
      setCalledAutoCheck(false);
    }
  }, [watchedEmployeeId, checkEmployee, calledAutoCheck]);

  const onEnter = () => {
    const employeeId = getValues('employeeId');
    checkEmployee(employeeId, {
      onSuccess: (res) => {
        const { result } = res;
        const branch = result.branchOptions.map((item) => ({
          label: item.label,
          value: item.value,
        }));
        setBranchOptions(branch);
        openAlert({
          type: 'success',
          message: res?.message,
          model: 'message',
        });
      },
      onError: (error) => {
        openAlert({
          type: 'error',
          message: error?.message,
          model: 'message',
        });
        setBranchOptions([]);
      },
    });
  };

  const onSubmit = () => {
    const employeeId = getValues('employeeId');
    const branchId = getValues('branchId');
    const payload = {
      employeeId,
      branchId,
      lineUid: userId,
      lineName: displayName,
    };
    loginEmployee(payload, {
      onSuccess: (res) => {
        openAlert({
          type: 'success',
          message: res?.message,
          model: 'message',
        });
        navigateTo({ pathname: ROUTES_PATH.ROUTE_SCAN_INCENTIVE.PATH, state: res });
      },
      onError: (error) => {
        openAlert({
          type: 'error',
          message: error?.message,
          model: 'message',
        });
      },
    });
  };

  return (
    <Spin spinning={loadingLogin}>
      <StyledContainer>
        <TextLarge
          text="เข้าสู่ระบบ"
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        />
        <RenderForm
          control={control}
          setValue={setValue}
          getValues={getValues}
          forms={FORM_LOGIN_EMPLOYEE({ onEnter, branchOptions })}
        />
        <ContainerButton center>
          <ButtonTheme useFor="SUBMIT_INCENTIVE" onClick={handleSubmit(onSubmit)} />
          <ButtonTheme useFor="CANCEL" />
        </ContainerButton>
      </StyledContainer>
    </Spin>
  );
};
